import { MenuItem } from 'primeng/api';

export interface MenuStateModel {
  barItems: MenuItem[];
  loaded: boolean;
}

export const MENU_STATE_DEFAULTS: MenuStateModel = {
  barItems: [],
  loaded: false,
};
